// Client-side filename validation — mirrors the authoritative rule in
// storage-api (FileTypeValidator.ts INVALID_FILENAME_PATTERNS). Kept in sync so
// users get an immediate, friendly error before the upload request is made.
//
// NOTE: patterns are defined without the /g flag on purpose — they are used
// with RegExp.test(), and a module-level /g regex retains `lastIndex` between
// calls, which would cause intermittent false negatives.
export const INVALID_FILENAME_PATTERNS: RegExp[] = [
  /\.\./, // Path traversal / consecutive dots (e.g. "report..xlsx")
  /[<>:"|?*]/, // Invalid filename characters
  /^\./, // Hidden files (leading dot)
  /\$/, // Dollar signs (often in malware)
  /~/, // Temporary files
];

export const INVALID_FILENAME_MESSAGE =
  'Filename contains invalid characters (e.g. consecutive dots, <>:"|?*, $, ~, or a leading dot). Please rename the file and try again.';

/**
 * Returns an error message if the filename is missing or matches a suspicious
 * pattern, otherwise null.
 */
export const getFileNameError = (fileName?: string): string | null => {
  if (!fileName) return "Filename is required.";
  if (INVALID_FILENAME_PATTERNS.some((pattern) => pattern.test(fileName))) {
    return INVALID_FILENAME_MESSAGE;
  }
  return null;
};
